import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from '@angular/core';
import { GridTemplateCell } from '@shared/modules/grid/abstractions/grid-template-cell';
import { SecurityGridData } from '../../models/security-grid-data';
import { GridColumn } from '@grid/abstractions';
import { SecurityStatusName } from '@shared/enums/security-status-name';

@Component({
  standalone: false,
  selector: 'gstar-security-status-grid-icon',
  templateUrl: './security-status-grid-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityStatusGridIconComponent
  implements GridTemplateCell<SecurityGridData>
{
  header: WritableSignal<GridColumn | undefined> = signal(undefined);
  row: WritableSignal<SecurityGridData | undefined> = signal(undefined);

  get approved(): SecurityStatusName {
    return SecurityStatusName.Approved;
  }

  get pendingApproval(): SecurityStatusName {
    return SecurityStatusName.PendingApproval;
  }

  get informationRequired(): SecurityStatusName {
    return SecurityStatusName.InformationRequired;
  }
}
